import { markAsBookedLiteStorefrontsSelector } from '@client/redux/experiments/selectors/mark-as-booked-lite-storefronts';
import { useAppSelector } from '@redux/hooks';

export const useIsMarkAsBookedLiteStorefrontsEnabled = () => {
	const assignment = useAppSelector(markAsBookedLiteStorefrontsSelector);
	return assignment === 'variant1';
};
